import React from 'react';
import { Button, Dropdown, Space } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import confirmDanger from './confirmDanger';

const DELETE_WARNING = 'Delete this checklist? Widgets using it will show nothing.';

const ChecklistEditorActions = ({
	busy,
	stale,
	canDelete,
	canSave,
	problem,
	onReload,
	onDelete,
	onSave,
}) => {
	const confirmDelete = () => confirmDanger(DELETE_WARNING, 'Delete', onDelete);

	return (
		<Space>
			{problem && <span className="ChecklistEditor-problem">{problem}</span>}
			{stale && (
				<Button loading={busy === 'reload'} disabled={!!busy} onClick={onReload}>
					Reload
				</Button>
			)}
			{canDelete && (
				<Dropdown
					trigger={['click']}
					disabled={!!busy}
					menu={{
						items: [{ key: 'delete', label: 'Delete checklist', danger: true }],
						onClick: confirmDelete,
					}}
				>
					<Button
						type="text"
						icon={<MoreOutlined />}
						aria-label="Checklist actions"
						loading={busy === 'delete'}
					/>
				</Dropdown>
			)}
			<Button
				type="primary"
				loading={busy === 'save'}
				disabled={!canSave || (!!busy && busy !== 'save')}
				onClick={onSave}
			>
				Save checklist
			</Button>
		</Space>
	);
};

export default ChecklistEditorActions;
